import { queryOptions } from '@tanstack/react-query';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

const method = api.getCompanyGuarantors;
type UseCompanyGuarantorsResponse = api.CompanyGuarantor[] | undefined;

export type CompanyGuarantor = api.CompanyGuarantor;

function getCompanyGuarantorsQuery(opts: RequestOpts = {}) {
  const queryKey = ['get-company-guarantors'];
  return queryOptions<UseCompanyGuarantorsResponse>({
    queryKey,
    queryFn: ({ signal }) => {
      return method({
        ...opts,
        signal,
      }) as Promise<UseCompanyGuarantorsResponse>;
    },
  });
}

export async function fetchCompanyGuarantorsQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getCompanyGuarantorsQuery(opts));
}
